import { MATTER_RELATED_STEP } from '@/constants/visualPrompts/matterStep';
import type { VisualPromptStep } from '@/types/visualPrompts/visualPrompt.types';

export const CUSTOM_PROMPT_COMPILE_TEMPLATE = `You are helping staff in a UK law firm with a task related to business systems, operations, or internal communications.

Task: {{task}}
Context: {{context}}
Audience: {{audience}}
Goal: {{goal}}
Tone: {{tone}}
Constraints: {{constraints}}
Output format: {{output}}

{{sourceText}}`;

export const buildDefaultCustomPromptSteps = (): VisualPromptStep[] => [
  {
    id: 'task',
    type: 'text',
    title: 'Task',
    description: 'What do you need help with?',
    mapsTo: 'task',
    required: true,
    placeholder: 'e.g. Summarise feedback on the new expenses process',
  },
  {
    id: 'context',
    type: 'text',
    title: 'Context',
    mapsTo: 'context',
    placeholder: 'System, department, rollout phase, or constraints',
  },
  MATTER_RELATED_STEP,
  {
    id: 'audience',
    type: 'singleSelectPills',
    title: 'Audience',
    mapsTo: 'audience',
    required: true,
    options: [
      { id: 'lawyers', label: 'Lawyers' },
      { id: 'business-services', label: 'Business services' },
      { id: 'it-ops', label: 'IT / systems team' },
      { id: 'leadership', label: 'Leadership' },
      { id: 'all-firm', label: 'All firm staff' },
    ],
  },
  {
    id: 'goal',
    type: 'text',
    title: 'Goal',
    mapsTo: 'goal',
    placeholder: 'What does success look like?',
  },
  {
    id: 'tone',
    type: 'singleSelectPills',
    title: 'Tone',
    mapsTo: 'tone',
    options: [
      { id: 'professional', label: 'Professional' },
      { id: 'supportive', label: 'Supportive / training' },
      { id: 'direct', label: 'Direct' },
      { id: 'plain', label: 'Plain English' },
    ],
  },
  {
    id: 'constraints',
    type: 'multiSelect',
    title: 'Constraints',
    mapsTo: 'constraints',
    options: [
      { id: 'brand', label: 'Follow brand guidelines' },
      { id: 'british', label: 'British English' },
      { id: 'short', label: 'Keep it brief' },
      { id: 'no-jargon', label: 'Avoid IT jargon' },
      { id: 'confidentiality', label: 'No client/matter-identifying content' },
    ],
  },
  {
    id: 'output',
    type: 'singleSelectPills',
    title: 'Output format',
    mapsTo: 'output',
    options: [
      { id: 'prose', label: 'Prose' },
      { id: 'bullets', label: 'Bullet points' },
      { id: 'table', label: 'Table' },
      { id: 'faq', label: 'FAQ' },
    ],
  },
  {
    id: 'source',
    type: 'textarea',
    title: 'Reference material (optional)',
    mapsTo: 'sourceText',
    placeholder: 'Or attach documents in Ask after you run',
  },
  { id: 'review', type: 'review', title: 'Review', mapsTo: '_review' },
];
